import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Stack,
  Button,
  IconButton,
  Tooltip,
  Chip,
  Divider,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

function ActionTray({
  metrics,
  handleDownload,
  handleExpandAll,
  handleCollapseAll,
  expandedIds,
  treeData,
  editable,
  handleAddRoot,
  handleReset,
  changed,
  handleUpdate,
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      p={2}
    >
      <Stack direction="row" spacing={2}>
        <Tooltip
          title="This is the maximum depth of the ontology"
          arrow
          placement="top"
        >
          <Chip
            label={`Max Depth: ${metrics.maxDepth}`}
            variant="outlined"
            sx={{ cursor: "help" }}
          />
        </Tooltip>
        <Tooltip
          title="This is the number of items in the ontology"
          arrow
          placement="top"
        >
          <Chip
            label={`Item Count: ${metrics.count}`}
            variant="outlined"
            sx={{ cursor: "help" }}
          />
        </Tooltip>
      </Stack>
      <Stack direction="row" spacing={2} justifyContent="right">
        <Tooltip title="Click to download this resource">
          <IconButton size="small" onClick={handleDownload} color="primary">
            <DownloadIcon />
          </IconButton>
        </Tooltip>
        <Divider orientation="vertical" flexItem />
        <Tooltip title="Click to expand all items">
          <IconButton
            size="small"
            onClick={handleExpandAll}
            color="primary"
            disabled={expandedIds.length === treeData.length}
          >
            <ExpandMoreIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Click to collapse all items">
          <IconButton
            size="small"
            onClick={handleCollapseAll}
            color="primary"
            disabled={expandedIds.length === 0}
          >
            <ExpandLessIcon />
          </IconButton>
        </Tooltip>
        {editable ? (
          <>
            <Button
              variant="contained"
              disableElevation
              color="primary"
              size="small"
              onClick={handleAddRoot}
            >
              Add root node
            </Button>
            <Divider orientation="vertical" flexItem />
            <Button
              variant="outlined"
              disableElevation
              color="primary"
              size="small"
              onClick={handleReset}
              disabled={!changed}
            >
              Reset
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={handleUpdate}
              // disabled={!valid || !changed}
            >
              Update
            </Button>
          </>
        ) : null}
      </Stack>
    </Stack>
  );
}

export default ActionTray;
